// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "lifecycleHooks": {
        "onMount": "loadLibraryDetails",
        "onUpdate": {
            "observers": [
                "props.accsessionid"
            ]
        }
    },
    "data": {
        "name": {
            "displayName": "{{i18n.catalogName}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "importDescription": {
            "dispValue": "{{i18n.importToLibraryDescription}}",
            "type": "STRING",
            "labelPosition": "NO_PROPERTY_LABEL"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        }
    },
    "actions": {
        "loadLibraryDetails": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {},
                        "query": "query queryLibraryComponentRevisions( $collaborationspaceId: String, $containerId: String) {queryLibraryComponentRevisions( collaborationspaceId: $collaborationspaceId, containerId: $containerId) }",
                        "variables": {
                            "collaborationspaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "loadedLibraryDetails": "data.data.queryLibraryComponentRevisions.response.results[0]"
            },
            "events": {
                "failure": [
                    {
                        "name": "loadLibraryDetailsFailure",
                        "eventData": {
                            "eventData": "{{loadedLibraryDetails}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "loadLibraryDetailsSuccess",
                        "eventData": {
                            "eventName": "loadLibraryDetailsSuccess",
                            "eventData": "{{loadedLibraryDetails}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updateloadedLibraryDetails": {
            "actionType": "JSFunction",
            "method": "updateloadedLibraryDetails",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "publishLibrary": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}",
                            "containerId": "{{props.libraryid}}"
                        },
                        "query": "mutation publishToCatalog( $urns: String) {publishToCatalog( urns: $urns) }",
                        "variables": {
                            "urns": "{{data.loadedLibraryDetails.data.revision.urn}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "publishLibraryresponse": "data.data.publishToCatalog"
            },
            "events": {
                "failure": [
                    {
                        "name": "desPublishLibraryFailure",
                        "condition": "conditions.publishLibraryCondition",
                        "eventData": "{{publishLibraryresponse.output.statusCode}}"
                    }
                ],
                "success": [
                    {
                        "name": "desPublishLibrarySuccess",
                        "condition": "conditions.publishLibraryCondition"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        }
    },
    "onEvent": [
        {
            "eventId": "loadLibraryDetailsSuccess",
            "action": "updateloadedLibraryDetails",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "desPublishLibrarySuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desPublishLibrarySuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "desPublishLibraryFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desPublishLibraryFailure",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "conditions": {
        "enablePublishButton": {
            "expression": "data.name.dbValue"
        },
        "publishLibraryCondition": {
            "expression": "publishLibraryresponse.output.success"
        }
    },
    "i18n": {
        "publishButton": [
            "DesLibraryMessages"
        ],
        "description": [
            "DesLibraryMessages"
        ],
        "catalogName": [
            "DesLibraryMessages"
        ],
        "importToLibraryDescription": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesLibraryPublish",
    "_uniqueViewModelId": "DesLibraryPublish",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-label prop="data.importDescription"></aw-label>
        <aw-textbox prop="data.name"></aw-textbox>
        <aw-break></aw-break>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button class="small" button-type='accent-high-contrast' action='publishLibrary'
            enable-when="conditions.enablePublishButton">{{i18n.publishButton}}
        </aw-button>
        <aw-break></aw-break>
    </aw-panel-footer>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwLabel {...getField("data.importDescription", fields, $index, null, null )}>
            </AwLabel>
            <AwTextbox {...getField("data.name", fields, $index, null, null )}>
            </AwTextbox>
            <AwBreak>
            </AwBreak>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen className="small" buttonType="accent-high-contrast" action={actions.publishLibrary} enableWhen={AwParseService.instance( "conditions.enablePublishButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.publishButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
            <AwBreak>
            </AwBreak>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;